import React from 'react';
import { useResponsive } from '../../hooks/useResponsive';

const TeamList = ({ teams, organizations, onEdit, onDelete, styles }) => {
  const { isDesktop } = useResponsive();

  if (teams.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
        No teams yet. Create one to get started.
      </div>
    );
  }

  return (
    <div style={styles.teamsContainer}>
      {organizations.map((org) => {
        const orgTeams = teams.filter((team) => team.organization_id === org.id);
        if (orgTeams.length === 0) return null;

        return (
          <div key={org.id} style={{ marginBottom: '30px' }}>
            <h3 style={styles.orgGroupTitle}>{org.name}</h3>

            {isDesktop ? (
              // Desktop: Table view
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>Team Name</th>
                    <th style={styles.th}>Division</th>
                    <th style={styles.th}>Season</th>
                    <th style={styles.th}>Head Coach</th>
                    <th style={styles.th}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {orgTeams.map((team) => (
                    <tr key={team.id}>
                      <td style={styles.td}>{team.name}</td>
                      <td style={styles.td}>{team.division || '-'}</td>
                      <td style={styles.td}>{team.season || '-'}</td>
                      <td style={styles.td}>{team.head_coach}</td>
                      <td style={styles.td}>
                        <div style={{ display: 'flex', gap: '8px' }}>
                          <button
                            style={{ ...styles.smallButton, ...styles.primaryButton }}
                            onClick={() => onEdit(team)}
                          >
                            Edit
                          </button>
                          <button
                            style={{ ...styles.smallButton, ...styles.dangerButton }}
                            onClick={() => onDelete(team)}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              // Mobile: Card view
              <div style={styles.cardContainer}>
                {orgTeams.map((team) => (
                  <div key={team.id} style={styles.teamCard}>
                    <div style={styles.teamCardHeader}>
                      <h3 style={styles.teamCardTitle}>{team.name}</h3>
                      {team.division && <span style={styles.badge}>{team.division}</span>}
                    </div>
                    <div style={styles.teamCardBody}>
                      {team.season && (
                        <p>
                          <strong>Season:</strong> {team.season}
                        </p>
                      )}
                      <p>
                        <strong>Head Coach:</strong> {team.head_coach}
                      </p>
                    </div>
                    <div style={styles.teamCardActions}>
                      <button
                        style={{ ...styles.button, ...styles.primaryButton }}
                        onClick={() => onEdit(team)}
                      >
                        Edit
                      </button>
                      <button
                        style={{ ...styles.button, ...styles.dangerButton }}
                        onClick={() => onDelete(team)}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default TeamList;
